import React from "react";
import "./CustomTab.css";

const CustomTab = ({
  dashboards = [],
  activeDashboard,
  setActiveDashboard,
}) => {
  const dashboardCount = dashboards?.length;

  if(dashboardCount > 1) {
    return (
      <div className="custom-tab-container">
        {dashboards.map((dashboard) => (
          <div
            title={dashboard.name}
            key={dashboard.id}
            className={`custom-tab ng_p_1_r overflow-ellipsis ${
              activeDashboard?.id === dashboard.id ? "active" : ""
            }`}
            onClick={() => setActiveDashboard(dashboard)}
          >
            {dashboard.name}
          </div>
        ))}
      </div>
    );
  }
};

export default CustomTab;
